<div class="register">
  <div class="container h-100">
    <div class="row align-items-center h-100 justify-content-center">
      <div class="card rounded-0 card-register border-0">

        <div class="text-center mb-3">
          <img src="assets/images/header-logo.png" />
        </div>

        <div class="card-body">
          <crm-alert #alert></crm-alert>

          <form *ngIf="isCodeValid" [formGroup]="registerForm" name="form" class="form" (ngSubmit)="onRegisterSubmit()">

            <div class="form-group row">
              <label for="inputFirstname" class="col-sm-3 col-form-label">Firstname</label>
              <div class="col-sm-8">
                <input type="text" formControlName="USER_NAME_FIRST" id="inputFirstname" name="USER_NAME_FIRST" class="form-control rounded-0"
                  placeholder="Your first name" required />
              </div>
            </div>

            <div class="form-group row">
              <label for="inputLastname" class="col-sm-3 col-form-label">Lastname</label>
              <div class="col-sm-8">
                <input type="text" formControlName="USER_NAME_LAST" id="inputLastname" name="USER_NAME_LAST" class="form-control rounded-0"
                  placeholder="Your last name" required />
              </div>
            </div>

            <div class="form-group row">
              <label for="inputPassword" class="col-sm-3 col-form-label">Password</label>
              <div class="col-sm-8">
                <input type="password" formControlName="USER_PASSWORD" id="inputPassword" name="USER_PASSWORD" class="form-control rounded-0"
                  placeholder="Password" required />
                <div class="form-text text-danger" *ngIf="registerForm.controls['USER_PASSWORD'].invalid && (registerForm.controls['USER_PASSWORD'].dirty ||registerForm.controls['USER_PASSWORD'].touched)">
                  <div *ngIf="registerForm.controls['USER_PASSWORD'].errors['pattern']"><small>
                    Password must be of 12 characters including at least 1 number and 1 capital letter</small> </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-6 mx-auto">
                <button [disabled]="!registerForm.valid" type="submit" class="btn btn-login btn-lg btn-block rounded-0">
                  Submit</button>
              </div>
            </div>
          </form>

          <div *ngIf="!isCodeValid" class="alert alert-danger text-center">
            <b>Invalid Code</b> <br>
            You have used invalid or already registered code.
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
